// ./src/components/generic/RouteFallback/RouteFallback.tsx
//
// What shows while a route's lazy chunk is downloading.
//
// ⚠⚠ IT IS INVISIBLE FOR THE FIRST MOMENT, ON PURPOSE. Until ROADMAP A2b #51 there was NO Suspense
// boundary in this app at all, so a first visit to a page blanked the screen until its chunk
// arrived — that is the "the whole layout gets reloaded, second visit is fine" report. But the
// obvious fix is its own bug: a spinner that appears and vanishes inside 80ms reads as a flicker,
// and on a warm cache that is every navigation. So this renders NOTHING for `DELAY_MS` and only
// then fades in — a fast load shows no loader at all, a slow one is explained.
//
// ⚠ The delay is CSS, not a timer. A `setTimeout` + state would schedule an update on a component
// that is very often unmounted before it fires, and React's Suspense already treats this subtree as
// throwaway. An animation with a delay costs nothing and cannot leak.
import React from "react";
import { Box, Loader } from "@mantine/core";

/** Long enough that a warm chunk never shows a loader; short enough that a cold one is explained. */
const DELAY_MS = 200;

export const RouteFallback: React.FC = () => (
  <Box
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "60vh",
      opacity: 0,
      animation: `em-route-fallback-in 160ms ease ${DELAY_MS}ms forwards`,
    }}
  >
    <style>{`@keyframes em-route-fallback-in { to { opacity: 1; } }`}</style>
    <Loader color="brand" size="md" />
  </Box>
);
